// 3rd party
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

// external
import { CommonClientRequestsModule } from '@aiwyn/common/client-requests';
import { ScrollShadowsDirective, SharedModule, UploadFilesModule } from '@aiwyn/shared';
import { CommonLayoutModule } from '@aiwyn/common/layout';

// internal
import {
  AddNoteModalComponent,
  ClientRequestComponent,
  ClientRequestFiltersComponent,
  ClientRequestServicesComponent,
  ClientRequestStaffComponent,
  DeletedDeliverableDialogComponent,
  DeliverableComponent,
  DocumentRequestModalComponent,
  FilesLinkModalComponent,
} from './components';

import {
  ActivityItemComponent,
  ClientRequestDetailsComponent,
  ClientRequestDocumentUploadTabComponent,
  ClientRequestGroupComponent,
  ClientRequestGroupsContainerComponent,
  ClientRequestNavigationTabComponent,
  ClientRequestPanelComponent,
  ClientRequestsPageComponent,
  ClientRequestSubmissionConfirmationDialogComponent,
  DocumentItemContentComponent,
  FileItemComponent,
  FlaggedFilesSummaryComponent,
  QuestionnaireItemContentComponent,
  ReassignModalComponent,
  RequestItemCardComponent,
  RequestItemLineComponent,
  RequestSectionComponent,
} from './containers';

import { NotApplicableContentComponent } from './containers/client-request-details/client-request-panel/components/request-item-card/components/not-applicable-content/not-applicable-content.component';
import { HasUploadedFilesPipe } from './containers/client-request-details/client-request-panel/pipes/has-uploaded-files.pipe';

import { ConfirmFlaggedFilesSubmissionComponent } from '../../components/main/modals/confirm-flagged-files-submission/confirm-flagged-files-submission.component';
import { ClientRequestsState } from './state';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { OverlayModule } from '@angular/cdk/overlay';
import { FileUploadJobItemComponent } from './containers/client-request-details/client-request-panel/components/file-upload-job-item/file-upload-job-item.component';
import { FileItemIconComponent } from './containers/client-request-details/client-request-panel/components/file-item-icon/file-item-icon.component';
import { FileSizePipe } from 'src/app/shared/pipes/file-size.pipe';
import { CommentsState } from './components/comments/state/comments.state';
import { CommentsSectionComponent } from './components/comments/comments-section/comments-section.component';
import { UnseenDotComponent } from './components/comments/unseen-dot/unseen-dot.component';

@NgModule({
  declarations: [
    AddNoteModalComponent,
    ClientRequestGroupComponent,
    ClientRequestFiltersComponent,
    ClientRequestServicesComponent,
    ClientRequestStaffComponent,
    ClientRequestsPageComponent,
    ClientRequestGroupsContainerComponent,
    ClientRequestComponent,
    ClientRequestDetailsComponent,
    ClientRequestPanelComponent,
    ClientRequestDocumentUploadTabComponent,
    ActivityItemComponent,
    RequestItemCardComponent,
    DocumentItemContentComponent,
    QuestionnaireItemContentComponent,
    ClientRequestNavigationTabComponent,
    RequestItemLineComponent,
    ClientRequestSubmissionConfirmationDialogComponent,
    DocumentRequestModalComponent,
    FilesLinkModalComponent,
    DeliverableComponent,
    DeletedDeliverableDialogComponent,
    ReassignModalComponent,
    RequestSectionComponent,
    FlaggedFilesSummaryComponent,
    NotApplicableContentComponent,
    FileItemComponent,
  ],
  imports: [
    CommonClientRequestsModule,
    OverlayModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    NgxsModule.forFeature([ClientRequestsState, CommentsState]),
    SharedModule,
    UploadFilesModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    CommonLayoutModule,
    MatSidenavModule,
    MatTabsModule,
    MatMenuModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    PdfViewerModule,
    MatError,
    ConfirmFlaggedFilesSubmissionComponent,
    HasUploadedFilesPipe,
    FileUploadJobItemComponent,
    FileItemIconComponent,
    FileSizePipe,
    CommentsSectionComponent,
    UnseenDotComponent,
    ScrollShadowsDirective,
  ],
  exports: [ClientRequestPanelComponent],
})
export class ClientRequestsModule {}
